/**
 * @class ScrollClass
 * use jquery
 */
export default class ScrollClass {
  /**
   * constructor
   */
  constructor($element, options) {

    this.isPC = true;
    if (window.matchMedia('(max-width:767px)').matches) {
      this.isPC = false;
    }
    // props
    this.defaults = {
      startPosition: (this.isPC) ? 100 : 40,
      addClassName: 'opj-action'
    };
    this.target = $element;
    this.$window = $(window)

    // optionsを代入
    if(options) {
      for (const key in options) {
        if (options.hasOwnProperty(key)) {
          this.defaults[key] = options[key];
        }
      }
    }

    this.setup();
  }

  /**
   * setup
   */
  setup() {
    this.addAction();

    this.$window.on('scroll',() => {
      this.addAction();
    });
  }

  /**
   * addAction
   */
  addAction() {
    var length = this.target.length;
    for (var i = 0; i < length; i++) {
      if (this.target.eq(i).hasClass(this.defaults.addClassName)) continue;

      var in_position = this.target.eq(i).offset().top + this.defaults.startPosition;
      var window_bottom_position = this.$window.scrollTop() + this.$window.height();
      if (in_position < window_bottom_position) {
        this.target.eq(i).addClass(this.defaults.addClassName);
      }
    }
  }
}